import React, { useEffect } from 'react';
import WeightingTable from './WeightingsTable';

const DayPartWeights = ({ dayPartWeights, changeMade, readOnly }) => {
    useEffect(() => {}, [dayPartWeights]);
    return (
        <div key={'daypartweights'}>
            <div
                style={{
                    fontSize: 15,
                    fontWeight: 500,
                    marginBottom: 12,
                    marginTop: 5
                }}
            >
                {window.translate('Dayparts')}
            </div>
            <div style={{ fontSize: 12, marginBottom: 12 }}>
                {window.translate('Spot Distribution across dayparts')}
            </div>

            <WeightingTable
                valuesIn={dayPartWeights}
                changeMade={changeMade}
                key='daypartweightsweightingtable'
                readOnly={readOnly}
            ></WeightingTable>
        </div>
    );
};
export default DayPartWeights;
